module.exports = "/img/_/_/_/assets/images/creeper/battle/common//14.jpg?28339c4096345bf49d144f6c5bc4fc8a";